import React from 'react';
import { Grid, Typography } from '@mui/material';
import Button from 'components/atoms/Button';
import { EButtonSizesPX, EButtonStyleVariant, EButtonVariants } from 'constants/Buttons';
import { EIconTypes } from 'constants/Icons';
import { StyledTitle } from 'pages/DashboardPage/styles';

const DashboardApplyforLicence = () => (
  <Grid container rowGap="20px">
    <Grid item xs={12}>
      <StyledTitle variant="h4">Apply for a licence</StyledTitle>
    </Grid>
    <Grid item xs={12} mb="20px">
      <Typography variant="body1">
        Apply for or renew a firearms, shotguns or explosives certificate. Whether you’re a
        firearms owner, firearms dealer, shooting club member or planning to travel with
        firearms, answer a few quick questions and we’ll guide you to the right form and
        everything you need to complete it.
      </Typography>
    </Grid>
    <Grid item container xs={12} columnSpacing="20px">
      <Grid item xs={12} md={6} lg={4}>
        <Button
          id="apply"
          variant={EButtonVariants.contained}
          label="Apply for a licence"
          onClick={() => {}}
          icon={EIconTypes.arrowRightLink}
          endIcon
          fullWidth
          sizePX={EButtonSizesPX.px48}
          styleVariant={EButtonStyleVariant.success}
        />
      </Grid>
    </Grid>
  </Grid>
);

export { DashboardApplyforLicence };
